/* Akoya – Kategoriewechsel ohne Seitenneuladen.

   Ein Klick auf einen Chip holt die Zielseite im Hintergrund und tauscht nur
   Header, Breadcrumbs und Produktraster aus. Die Chipleiste bleibt stehen –
   inklusive ihrer Scrollposition auf dem Handy.

   Der Kollektions-Header wird nicht hart ersetzt, sondern ueberblendet: die
   neue Hintergrundschicht wird ueber die alte gelegt, erst nach dem Laden
   eingeblendet und die alte danach entfernt. Der Text wechselt in der Mitte
   der Blende, solange er unsichtbar ist.

   Zwischengespeichert wird HTML-Text, nicht ein geparstes Dokument – sonst
   waeren dessen Knoten nach dem ersten Einsetzen verschoben und weg.

   Ohne JavaScript funktionieren die Links ganz normal. */

(function () {
  var CACHE_LIMIT = 12;
  var FADE_IN = 500;
  var TEXT_OUT = 180;

  var cache = new Map();
  var pending = null;

  if (!window.fetch || !window.DOMParser || !window.history.pushState) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function subnav() {
    return document.querySelector('.akoya-subnav--collection');
  }

  function isPlainClick(event) {
    return !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0);
  }

  function sameOrigin(url) {
    try {
      return new URL(url, location.href).origin === location.origin;
    } catch (error) {
      return false;
    }
  }

  function fetchHtml(url) {
    var key = new URL(url, location.href).href;
    if (cache.has(key)) return cache.get(key);

    var request = fetch(key, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('bad response');
      return response.text();
    });

    request.catch(function () {
      cache.delete(key);
    });

    if (cache.size >= CACHE_LIMIT) cache.delete(cache.keys().next().value);
    cache.set(key, request);

    return request;
  }

  /** Bild der Zielseite schon beim Vorladen in den Browser-Cache holen. */
  function warmHeroImage(html) {
    var match = html.match(/class="akoya-collection-hero__image"[^>]*src="([^"]+)"/);
    if (!match) return;
    var image = new Image();
    image.src = match[1].replace(/&amp;/g, '&');
  }

  /** Wartet, bis die Hintergrundschicht wirklich zeigbar ist. */
  function layerReady(layer) {
    var image = layer.querySelector('img');
    if (!image) return Promise.resolve();
    if (image.decode) return image.decode().catch(function () {});
    if (image.complete) return Promise.resolve();
    return new Promise(function (resolve) {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
      window.setTimeout(resolve, 1200);
    });
  }

  function centerActiveChip(behavior) {
    var bar = subnav();
    if (!bar) return;

    var list = bar.querySelector('.akoya-subnav__list');
    var active = bar.querySelector('.akoya-subnav__link--active');
    if (!list || !active || list.scrollWidth <= list.clientWidth) return;

    var target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
    list.scrollTo({ left: Math.max(0, target), behavior: reduced ? 'auto' : behavior || 'auto' });
  }

  function markActive(link) {
    var bar = subnav();
    if (!bar) return;

    bar.querySelectorAll('.akoya-subnav__link').forEach(function (item) {
      var isActive = item === link;
      item.classList.toggle('akoya-subnav__link--active', isActive);
      if (isActive) {
        item.setAttribute('aria-current', 'page');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  }

  function markActiveByUrl(url) {
    var bar = subnav();
    if (!bar) return;

    var path = new URL(url, location.href).pathname;
    var match = null;

    bar.querySelectorAll('.akoya-subnav__link').forEach(function (item) {
      if (new URL(item.href, location.href).pathname === path) match = item;
    });

    if (match) markActive(match);
  }

  /** Hintergrund ueberblenden, Text in der Mitte tauschen. */
  function crossfadeHero(nextHero) {
    var hero = document.querySelector('.akoya-collection-hero');
    if (!hero || !nextHero) return;

    var nextMedia = nextHero.querySelector('.akoya-collection-hero__media');
    var nextInner = nextHero.querySelector('.akoya-collection-hero__inner');
    var nextIsMedia = nextHero.classList.contains('akoya-collection-hero--media');

    if (reduced) {
      hero.replaceWith(nextHero.cloneNode(true));
      return;
    }

    var layer;

    if (nextMedia) {
      layer = nextMedia.cloneNode(true);
    } else {
      layer = document.createElement('div');
      layer.className = 'akoya-collection-hero__media akoya-collection-hero__media--plain';
    }

    layer.dataset.akoyaHeroLayer = 'incoming';
    layer.style.opacity = '0';
    layer.style.transition = 'opacity ' + FADE_IN + 'ms var(--akoya-ease, ease)';
    hero.appendChild(layer);

    var inner = hero.querySelector('.akoya-collection-hero__inner');
    if (inner) {
      inner.style.transition = 'opacity ' + TEXT_OUT + 'ms var(--akoya-ease, ease)';
      inner.style.opacity = '0';
    }

    layerReady(layer).then(function () {
      requestAnimationFrame(function () {
        layer.style.opacity = '1';
      });

      // Text wechseln, solange er unsichtbar ist – dann faellt auch der
      // Farbwechsel (Cream auf Bild, Ink auf Sandband) nicht auf.
      window.setTimeout(function () {
        if (inner && nextInner) {
          var freshInner = nextInner.cloneNode(true);
          freshInner.style.opacity = '0';
          freshInner.style.transition = 'opacity 260ms var(--akoya-ease, ease)';
          inner.replaceWith(freshInner);
          requestAnimationFrame(function () {
            freshInner.style.opacity = '1';
          });
        }

        hero.classList.toggle('akoya-collection-hero--media', nextIsMedia);
        hero.classList.toggle('akoya-collection-hero--plain', !nextIsMedia);
      }, TEXT_OUT);

      // Alte Schichten entfernen, sobald die neue vollstaendig sichtbar ist
      window.setTimeout(function () {
        hero.querySelectorAll('.akoya-collection-hero__media').forEach(function (node) {
          if (node !== layer) node.remove();
        });
        layer.removeAttribute('data-akoya-hero-layer');
        layer.style.transition = '';
      }, FADE_IN + 60);
    });
  }

  function swapRest(doc) {
    ['.akoya-breadcrumbs', 'collection-component'].forEach(function (selector) {
      var current = document.querySelector(selector);
      var incoming = doc.querySelector(selector);
      if (!current || !incoming) return;
      current.replaceWith(incoming.cloneNode(true));
    });
  }

  function go(url, push) {
    var token = {};
    pending = token;

    document.documentElement.classList.add('akoya-subnav-loading');

    fetchHtml(url)
      .then(function (html) {
        if (pending !== token) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');

        crossfadeHero(doc.querySelector('.akoya-collection-hero'));
        swapRest(doc);

        if (doc.title) document.title = doc.title;
        if (push) window.history.pushState({ akoyaSubnav: true }, '', url);

        markActiveByUrl(url);
        centerActiveChip('smooth');

        var bar = subnav();
        if (bar && bar.getBoundingClientRect().top < 0) {
          window.scrollTo({ top: bar.offsetTop - 120, behavior: 'auto' });
        }
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        if (pending === token) {
          pending = null;
          document.documentElement.classList.remove('akoya-subnav-loading');
        }
      });
  }

  function prefetch(event) {
    var link = event.target.closest && event.target.closest('.akoya-subnav--collection .akoya-subnav__link');
    if (!link || !sameOrigin(link.href)) return;
    fetchHtml(link.href)
      .then(warmHeroImage)
      .catch(function () {});
  }

  document.addEventListener('pointerenter', prefetch, true);
  document.addEventListener('touchstart', prefetch, { passive: true, capture: true });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.akoya-subnav--collection .akoya-subnav__link');
    if (!link || !isPlainClick(event) || !sameOrigin(link.href)) return;
    if (!document.querySelector('collection-component')) return;

    event.preventDefault();

    if (new URL(link.href, location.href).pathname === location.pathname) return;

    markActive(link);
    centerActiveChip('smooth');
    go(link.href, true);
  });

  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.akoyaSubnav) return;
    if (!document.querySelector('collection-component')) return;
    go(location.href, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      centerActiveChip('auto');
    });
  } else {
    centerActiveChip('auto');
  }
})();